/**
 * The highest server `version` this client has observed for the current session (AVS-4330).
 *
 * Deliberately dependency-free: both `state/session` (which seeds it from PUT/POST/GET
 * responses) and `state/session/applyRemote` (which gates broadcasts on it) need it, so
 * keeping the state here avoids an import cycle between them.
 */

let lastSeenVersion: number | undefined;

export function getLastSeenVersion(): number | undefined {
  return lastSeenVersion;
}

/** Advance the baseline from a server response. Never moves backwards. */
export function seedRemoteVersion(version?: number): void {
  if (typeof version === 'number' && (lastSeenVersion === undefined || version > lastSeenVersion)) {
    lastSeenVersion = version;
  }
}

/** Entering a different session invalidates the counter — versions are per session record. */
export function resetRemoteVersion(): void {
  lastSeenVersion = undefined;
}
